import { Box, Stack } from "@mui/material";
import LazyLoading from "../../Wrappers/components/LazyLoading";
import { ITopBarWrapper } from "./types";

const TopBarWrapper: React.FC<ITopBarWrapper> = ({
  wrappedComponent,
  components,
}) => {
  const { TopBar } = components;

  return (
    <Stack
      sx={{
        width: "100%",
        position: "relative",
        margin: "0 auto auto auto",
      }}
      justifyContent="center"
    >
      <TopBar />
      <Box
        sx={{
          width: "100%",
          paddingTop: 0,
          paddingBottom: 6,
          boxSizing: "border-box",
        }}
      >
        <LazyLoading component={wrappedComponent} />
      </Box>
    </Stack>
  );
};

export default TopBarWrapper;
